module.exports = __webpack_public_path__ + "static/media/img10.8dbef2da.jpg";